"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityTypes = void 0;
exports.entityTypes = [
    { name: 'Warehouse', value: 'warehouse', code: 'w' },
    { name: 'Freight carrier', value: 'carrier', code: 'c' },
];
